import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import "./HorizontalBrandList.css";
import CircleLetterLogo from "../../component/circleLetterLogo/CircleLetterLogo";
import { brandUrl } from "../../util/url";

/**
 * 브랜드 horizontal 리스트
 * @param brands
 * @param title
 * @returns {React.JSX.Element|null}
 * @constructor
 */
const HorizontalBrandList = ({ brands, title }) => {
  if (!brands || brands.length === 0) return null;

  return (
    <div className="horizontal-brand-list">
      <h2 className="horizontal-brand-list-title">{title}</h2>
      <ul className="horizontal-brand-scroll" aria-label={`${title} 목록`}>
        {brands.map((brand) => (
          <li key={brand.id} className="horizontal-brand-item">
            <Link to={brandUrl(brand.name)}>
              <div className="horizontal-brand-logo">
                <CircleLetterLogo
                  logo={brand.resizedSmallLogo}
                  name={brand.name}
                  size={56}
                />
              </div>
              <div className="horizontal-brand-info">
                <h3 className="horizontal-brand-name">{brand.name}</h3>
                <div className="horizontal-brand-followers">
                  {brand.follow_count.toLocaleString()} 팔로워
                </div>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

HorizontalBrandList.propTypes = {
  brands: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      resizedSmallLogo: PropTypes.string,
      follow_count: PropTypes.number,
    }),
  ),
  title: PropTypes.string,
};

export default HorizontalBrandList;
